var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-button',{attrs:{"icon":"mdi-logout","label":"logout"},on:{"click":_vm.logout}})}
var staticRenderFns = []

export { render, staticRenderFns }